// Client-side image compression before upload.
// Applies EXIF orientation (phone photos) via createImageBitmap, downscales the
// longest edge and re-encodes as JPEG to keep the upload/storage size small.
export async function compressImage(file, { maxSize = 1600, quality = 0.8 } = {}) {
  if (!file || !file.type || !file.type.startsWith("image/")) return file;
  try {
    let bitmap;
    try {
      bitmap = await createImageBitmap(file, { imageOrientation: "from-image" });
    } catch {
      bitmap = await createImageBitmap(file);
    }
    let { width, height } = bitmap;
    const scale = Math.min(1, maxSize / Math.max(width, height));
    width = Math.max(1, Math.round(width * scale));
    height = Math.max(1, Math.round(height * scale));

    const canvas = document.createElement("canvas");
    canvas.width = width;
    canvas.height = height;
    const ctx = canvas.getContext("2d");
    ctx.drawImage(bitmap, 0, 0, width, height);
    if (bitmap.close) bitmap.close();

    const blob = await new Promise((res) =>
      canvas.toBlob(res, "image/jpeg", quality)
    );
    if (!blob) return file;

    const name = (file.name || "foto").replace(/\.[^.]+$/, "") + ".jpg";
    return new File([blob], name, { type: "image/jpeg", lastModified: Date.now() });
  } catch {
    return file;
  }
}
